import { faCheck } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";

export default function ProjectCard({
  campaign,
  selected,
  onSelect,
  extraFields,
}: {
  campaign: any;
  selected: boolean;
  onSelect?: (
    p: { ID: number; UUID: string; Reference: string } | undefined
  ) => void;
  extraFields?: (project: {
    ID: number;
    UUID: string;
    Reference: string;
  }) => React.ReactNode;
}) {
  return (
    <div key={campaign.ID} className={`${selected ? "" : "opacity-75"}`}>
      <button
        type="button"
        className={`btn h-100 w-100 bg-white p-3 text-start rounded-3 position-relative border border-2 ${
          selected ? "border-blue" : ""
        }`}
        style={{ cursor: onSelect ? "pointer" : "default" }}
        onClick={() => {
          onSelect?.(campaign);
        }}
      >
        {selected ? (
          <FontAwesomeIcon
            icon={faCheck}
            className="position-absolute top-0 end-0 text-white bg-colored p-2"
            style={{
              borderBottomLeftRadius: 8,
            }}
          />
        ) : null}
        <div className="d-flex align-items-center">
          <div className=" w-100">
            <h5 className="text-blue fw-bold">{campaign.Label} </h5>
            {/* <div className="text-secondary small">ID: #{campaign.ID}</div> */}
            <div className="text-secondary small">
              Ref: {campaign.Reference}
            </div>
            <div className="text-secondary small">
              Description: {campaign.Description}
            </div>
            {extraFields?.(campaign)}
          </div>
        </div>
      </button>
    </div>
  );
}
